<template>
  <ul class="dropdown-menu">
    <div v-for="menuRoot in items" :key="menuRoot.key" class="am-dropdown dropdown-submenu">
      <li><a class="dropdown-item" href="#">{{ menuRoot.title }}</a></li>
      <ul class="dropdown-menu">
        <div v-if="menuRoot.items[0].title !== null" v-for="subItem in menuRoot.items" :key="subItem.key" class="am-dropdown dropdown-submenu">
          <li><a class="dropdown-item" href="#">{{ subItem.title }}</a></li>
          <ul class="dropdown-menu">
            <li v-for="subSubItem in subItem.items" :key="subSubItem.key">
            <a class="dropdown-item" :href="subSubItem.target">{{subSubItem.title}}</a></li>
          </ul>
        </div>
        <div v-if="menuRoot.items[0].title === null" v-for="subItem in menuRoot.items[0].items" :key="subItem.key" >
          <li><a class="dropdown-item" :href="subItem.target">{{ subItem.title }}</a></li>
        </div>
      </ul>
    </div>
  </ul>
</template>

<script>
import OldLink from '@/components/OldLink'

export default {
  name: 'HeaderDropDown',

  components: {
    OldLink
  },
  props: {
    items: Array
  }
}
</script>

<style>
  .am-dropdown {
    position: relative;
  }

  .dropdown-menu {
    font-size: 11px;
    display: none;
    position: absolute;
    box-shadow: 0px 10px 20px 0px rgba(0,0,0,0.4);
    z-index: 1;
  }

  .am-dropdown .dropdown-menu {
    margin-top: -1px;
    padding: 1px 0px 0px 0px;
  }

  .dropdown-menu a {
    color: #ffffff;
    text-decoration: none;
    display: block;
  }

  .dropdown-item {
    font-weight: 700;
  }

  .dropdown-menu a:hover {
    color: #ffffff;
  }

  .dropdown-submenu>.dropdown-menu {
    top: 1px;
    left: 100%;
    margin-top: -3px;
    margin-left: -1px;
    border-radius: 0 6px 6px 6px;
  }

  .dropdown-submenu:hover>.dropdown-menu {
    display: block;
  }

  .dropdown-submenu > li > a:after{
    display: block;
    content: " ";
    float: right;
    width: auto;
    height: 0;
    border-color: transparent;
    border-style: solid;
    border-width: 5px 0 5px 5px;
    border-left-color: #ccc;
    margin-top: 5px;
    margin-right: -13px;
  }

</style>
